const consts = {
  BRAND_HEADER: 'BrandHeader',
  BRAND_NAVIGATION_TOP_MENU: 'BrandNavigationTopMenu',
  BRAND_NAVIGATION_TOP_MENU_BAR: 'BrandNavigationTopMenu-bar',
  BRAND_SUB_NAVIGATION_BREADCRUMB: 'BrandSubNavBreadcrumb',
  BRAND_NAVIGATION_TOP_MENU_VISIBLE: 'BrandNavigationTopMenu--visible',
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN: 'BrandNavigationTopMenu-bar-visibilityBtn',
  BRAND_NAVIGATION_TOP_MENU_LINK: 'BrandNavigationTopMenu-link',
  BRAND_NAVIGATION_NO_SCROLL: 'BrandNavigationTopMenu--noScroll',
  BRAND_NAVIGATION_TOP_MENU_LINK_EXPANDABLE: 'BrandNavigationTopMenu-link--expandable',
  BRAND_NAVIGATION_DROPDOWN_LINK_EXPANDABLE: 'BrandNavigationDropDown-link--expandable',
  BRAND_NAVIGATION_TOP_MENU_BURGERTOGGLE: 'BrandNavigationTopMenu-burgerToggle',
  BRAND_NAVIGATION_DROPDOWN_GRID: 'BrandNavigationDropDown-grid',
  BRAND_NAVIGATION_TOP_MENU_LINK_LOGOUT: 'BrandNavigationTopMenu-link-logOut',
  BRAND_SPEC_RUN_MODE: 'BrandNavigationRunMode',
  BRAND_IS_VISIBLE: 'is-visible'
}
export { consts }



// WEBPACK FOOTER //
// ./src/components/top-navigation/js/consts.js